import { createSlice } from "@reduxjs/toolkit";

//STATE
const initialState = {
  rows: [],
  isLoading: false,
};

//STORE SLICE
export const forRentCostumesListSlice = createSlice({
  name: "forRentCostumesListSlice",
  initialState,
  //REDUCER
  reducers: {
    setForRentCostumesList(state, action) {
      return {
        ...state,
        rows: action.payload,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
});

//ACTIONS
export const {
    setForRentCostumesList,
    showLoading,
    hideLoading,
} = forRentCostumesListSlice.actions;

export default forRentCostumesListSlice.reducer;
